export const SUPPORTS_ARRAY_PROTOTYPE_ENTRIES = "entries" in Array.prototype;
